import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '@/libs/firebase/config';
import { useUserSession } from '@/hooks/use-user-session';
import { resolvePremiumStatus } from '@/utils/resolve-premium-status';

export function usePremiumStatus() {
  const userId = useUserSession();
  const [status, setStatus] = useState({ loading: true, isPremium: false, expiresAt: null });

  useEffect(() => {
    if (userId === undefined) {
      setStatus((prev) => ({ ...prev, loading: true }));
      return undefined;
    }
    if (userId === null) {
      setStatus({ loading: false, isPremium: false, expiresAt: null });
      return undefined;
    }

    setStatus((prev) => ({ ...prev, loading: true }));

    const unsubscribe = onSnapshot(
      doc(db, 'users', userId),
      (snap) => {
        if (!snap.exists()) {
          setStatus({ loading: false, isPremium: false, expiresAt: null });
          return;
        }

        const data = snap.data();
        const premiumStatus = resolvePremiumStatus(data);
        
        setStatus({
          loading: false,
          isPremium: premiumStatus.isPremium,
          expiresAt: premiumStatus.expiresAt,
        });
      },
      (error) => {
        console.error('Error fetching premium status:', error);
        setStatus({ loading: false, isPremium: false, expiresAt: null });
      }
    );

    return () => unsubscribe();
  }, [userId]);

  return status;
} 